import { divWithStyle } from '@tableau/vizportalclient-common-components';
import { TabStyles} from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { cssClass, Style, textEllipsis } from '../../../style';
import { CARD_POPOVER_WIDTH } from './CardViewStyles';



const cssPrefix = 'CardViewDetailsTooltip';

export namespace DetailsTooltipStyles {

  export const Width = CARD_POPOVER_WIDTH - 70; // leave room for padding and vertical scroll bar
  const AnchorBlue = '#1A699E'; // from TFS 929971

  const Colors = TabStyles.Colors!;
  const lightBorder = '1px solid ' + Colors.F5;
  const selectedBorder = '1px solid ' + AnchorBlue;

  export const DetailsTooltip = cssClass(cssPrefix, 'details-tooltip', {
    fontWeight: 'normal',
    width: Width,
    paddingTop: 6,
    lineHeight: '14px',
    fontSize: '12px',
    color: TabStyles.Typography.Color.Primary,
  });

  export const DescriptionList = cssClass(cssPrefix, 'description-list', {
    display: 'grid',
    gridTemplateColumns: 'max-content',
    gap: '0px 12px'
  });

  export const DescriptionTerm = cssClass(cssPrefix, 'description-term', {
    marginTop: TabStyles.Spacing.LargeSpace,
    fontWeight: 'bold',
    $nest: {
      '&:first-of-type': {
        marginTop: 0
      }
    }
  });

  export const DescriptionDetails = cssClass(cssPrefix, 'description-details', {
    marginLeft: 0,
    gridColumnStart: 2,
    alignSelf: 'end'
  });

  export const DatasourceDetailsTooltip = cssClass(cssPrefix, 'datasource-details-tooltip', {
    fontWeight: 'normal',
    minWidth: 160,
    maxWidth: 365,
    flexGrow: 2,
    paddingTop: 6,
    lineHeight: '14px',
    fontSize: '12px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: TabStyles.Typography.Color.Primary,
  });

  export const EntityName = cssClass(cssPrefix, 'entity-name', {
    lineHeight: '21px',
    fontWeight: 'bold',
    fontSize: '14px',
    maxHeight: '1.5em * 5',
    wordWrap: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: TabStyles.Spacing.LargeSpace,
    marginTop: 0
  });

  export const MetadataSection = cssClass(cssPrefix, 'metadata-section', textEllipsis, {
    marginBottom: TabStyles.Spacing.LargeSpace,
    $nest: {
      '&:last-of-type': {
        marginBottom: 0
      }
    }
  });

  export const MetadataSectionWithContentDescription = cssClass(cssPrefix, 'metadata-content-description-section', {
    marginBottom: TabStyles.Spacing.ExtraLargeSpace
  });

  export const MetadataSectionWithCertifierDetails = cssClass(cssPrefix, 'metadata-certifier-details-section', {
    marginTop: TabStyles.Spacing.LargeSpace
  });

  export const MetadataTitle = cssClass(cssPrefix, 'metadata-title', {
    fontWeight: 'bold',
  });

  export const MultiLineTitle = cssClass(cssPrefix, 'metadata-multiline-title', {
    fontWeight: 'bold',
    marginBottom: TabStyles.Spacing.MediumSpace
  });

  export const lineageIconButtonStyle: Style = {
    height: '35px',
  };
  export const lineageIconButtonClass = cssClass(cssPrefix, 'lineageIconButton', lineageIconButtonStyle);
  export const cartoucheIconButtonStyle: Style = {
  ...lineageIconButtonStyle,
  $nest: {
    '&:not(:last-of-type)': {
      marginBottom: TabStyles.Spacing.LargeSpace
    }
  }
};

  export const activeLineageItemType = cssClass(cssPrefix,'activeLineageItemType', {
    border: selectedBorder,
    backgroundColor: AnchorBlue
  });

  // Defines the circular boundary for tooltip icons
  export const cartoucheIcon: Style = {
    border: lightBorder,
    borderRadius: '50%',
    padding: '4.5px',
    width: '15px',
    height: '15px',
    marginRight: '6px',
    verticalAlign: 'top',
    marginBottom:'18px',
    position:'absolute',
    display: 'flex'
  };

  // Defines grey background for surrounding cartouche of tooltip icons
  export const cartoucheIconWithBackground: Style = {
    ...cartoucheIcon,
    backgroundColor: CommonStyles.Colors.Grey235
  };

  // Defines clear background for surrounding cartouche of tooltip icons
  export const cartoucheIconWithoutBackground: Style = {
    ...cartoucheIcon,
    backgroundColor: CommonStyles.Colors.White
  };

  // Defines placement/sizing of icon images internal to backgrounded cartouche
  export const cartoucheIconImageWithBackground: Style = {

  };

  // Defines placement/sizing of icon images internal to clear cartouche
  export const cartoucheIconImageWithoutBackground: Style = {};

  export const cartoucheIconWithBackgroundClass = cssClass(cssPrefix,'cartoucheIconWithBackground', cartoucheIconWithBackground);

  export const cartoucheIconImageWithBackgroundClass = cssClass(cssPrefix,'cartoucheIconImageWithBackground', cartoucheIconImageWithBackground);

  export const cartoucheIconWithoutBackgroundClass = cssClass(cssPrefix,'cartoucheIconWithoutBackground', cartoucheIconWithoutBackground);

  export const cartoucheIconImageWithoutBackgroundClass = cssClass(cssPrefix,'cartoucheIconImageWithoutBackground', cartoucheIconImageWithoutBackground);

  export const CartoucheConnectorLine = divWithStyle('CartoucheConnectorLine', {
    width: 12.5,
    borderRight: lightBorder,
    height: '58px',
    position: 'absolute',
    marginTop: '10px'
  });

  export const cartoucheIconButtonClass = cssClass(cssPrefix,'cartoucheIconButton', cartoucheIconButtonStyle);

  export const ContentTypeIcon = cssClass(cssPrefix, 'content-type-icon', {
    height: '100%',
    marginRight: 6,
    verticalAlign: 'top',
  });

  export const MetadataValue = cssClass(cssPrefix, 'metadata-value', {
    marginLeft: TabStyles.Spacing.MediumSpace
  });

  export const TooltipMetadataValueHeading = cssClass(cssPrefix, 'tooltip-metadata-value-heading', {
    marginLeft: TabStyles.Spacing.MediumSpace,
    display: 'flex',
    marginBottom: '4px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  });

  export const TooltipMetadataValue = cssClass(cssPrefix, 'tooltip-metadata-value', {
    marginLeft: '34px',
    marginBottom: '4px',
    marginTop: '4px',
    marginRight: '16px'
  });

  export const TooltipMetadataValueHighlight = cssClass(cssPrefix, 'tooltip-metadata-value-highlight', {
    marginLeft: '34px',
    marginTop: '4px',
    marginRight: '16px',
    fontWeight: 'bold'
  });

  export const MetadataRelatedList = cssClass(cssPrefix, 'metadata-list', textEllipsis, {
    display: 'flex',
    flexDirection:'column',
    flexGrow: 1,
    minWidth: 0
  });

  export const metadataLineHeight = 20;

  export const MetadataLinkValueStyle: React.CSSProperties = {
    lineHeight: metadataLineHeight + 'px'
  };

  export const IconMetadataLinkValueStyle: React.CSSProperties = {
    marginLeft: '0px',
    lineHeight: metadataLineHeight + 'px',
    marginTop: '2px',
  };

  export const MetadataLinkValue = cssClass(cssPrefix, 'metadata-link-value', textEllipsis, {
    ...MetadataLinkValueStyle
  });

  export const IconMetadataLinkValue = cssClass(cssPrefix, 'icon-metadata-link-value', textEllipsis, {
    ...IconMetadataLinkValueStyle
  });

  export const MetadataLinks = cssClass(cssPrefix, 'metadata-value', {
    display: 'inline-block',
    marginRight: TabStyles.Spacing.DefaultSpace
  });

  export const NameMetadata = cssClass(cssPrefix, 'name-metadata-value', {
    display: 'inline-block',
    marginLeft: '2px',
    marginTop: '2px',
    marginBottom: '2px',
    fontSize: '10px',
    color: CommonStyles.Colors.NormalTextColor,
  });

  const MetadataValueMultilineStyle: Style = {
    whiteSpace: 'normal',
    lineHeight: '1.5em',
  };

  const MetadataTextMultilineStyle: Style = {
    ...MetadataValueMultilineStyle,
    marginTop: TabStyles.Spacing.DefaultSpace,
  };

  const MetadataLinksMultilineStyle: Style = {
    ...MetadataValueMultilineStyle,
    marginTop: TabStyles.Spacing.MediumSpace,
  };

  export const MetadataValueContentDescription = cssClass(cssPrefix, 'metadata-content-description',
    MetadataValueMultilineStyle);

  export const MetadataTextDescription = cssClass(cssPrefix, 'metadata-text-description',
    MetadataTextMultilineStyle);

  export const ToolTipMetadataTextDescription = cssClass(cssPrefix, 'tooltip-metadata-text-description',
  MetadataLinkValueStyle);

  export const MetadataLinksDescription = cssClass(cssPrefix, 'metadata-links-description',
    MetadataLinksMultilineStyle);

  export const RecommendationUsernameAdjust = cssClass(cssPrefix, 'recommendation-username-adjust', {
    marginTop: TabStyles.Spacing.DefaultSpace
  });

  export const SharedWithMeContentDescription = cssClass(cssPrefix, 'shared-with-me-content-description', {
    ...MetadataValueMultilineStyle,
    wordBreak: 'break-word',
  });

  export const SharedWithMeMetadata = cssClass(cssPrefix, 'shared-with-me-metadata', {
    display: 'flex',
    lineHeight: '1.5em',
    margin: '20px 0px',
    wordBreak: 'break-word',
  });
}
